import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/auth';
import { Toaster } from 'sonner';
import LandingPage from './pages/LandingPage';
import PrivacyPage from './pages/PrivacyPage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import Users from './pages/admin/Users';
import UserDetail from './pages/admin/UserDetail';
import Analytics from './pages/admin/Analytics';
import CoachConfig from './pages/admin/CoachConfig';
import Notifications from './pages/admin/Notifications';
import Templates from './pages/admin/Templates';
import System from './pages/admin/System';
import './App.css';

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#050505] flex items-center justify-center"><div className="w-8 h-8 border-2 border-[#CCFF00] border-t-transparent rounded-full animate-spin" /></div>;
  if (!isAuthenticated) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" theme="dark" toastOptions={{ style: { background: '#121212', border: '1px solid rgba(255,255,255,0.1)', color: '#fff' } }} />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/en" element={<LandingPage />} />
          <Route path="/personvern" element={<PrivacyPage />} />
          <Route path="/en/privacy" element={<PrivacyPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="users" element={<Users />} />
            <Route path="users/:userId" element={<UserDetail />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="coach" element={<CoachConfig />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="templates" element={<Templates />} />
            <Route path="system" element={<System />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
